import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { CHANGE_PASSWORD_PATH } from '@web/core/auth/password-change';
import { meQueryOptions } from '@web/core/auth/session';
import { AuthLayout } from '@web/modules/auth/auth-layout';

/**
 * Pathless layout of the sign-in screens (`/login`, `/register`, `/forgot-password`,
 * `/reset-password`), outside the app shell. Someone already signed in goes home — or, with a
 * temporary password still to replace, to `/change-password`.
 */
export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions).catch(() => null);
    // Platform operators belong in the admin app — keep them on the login screens here.
    if (me?.membership.role === 'platform-admin') return;
    if (me?.user.mustChangePassword) throw redirect({ to: CHANGE_PASSWORD_PATH, replace: true });
    if (me) throw redirect({ to: '/', replace: true });
  },
  component: () => (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  ),
});
